<style lang="less">
@import (reference) "../../../css/core/color.less";

.wx-titlebar {

	padding:10px 0 12px; border-bottom:1px solid @borderColor;

	//覆盖element样式
	.el-breadcrumb__inner{
		cursor:pointer;
		font-weight:normal;
	}
	.el-breadcrumb__item:last-child .el-breadcrumb__inner{
		cursor:defaut;
	}
	.el-breadcrumb__inner,
	.el-breadcrumb__item:last-child .el-breadcrumb__inner{
		font-size:16px;
		color:darken(@color,5%);
	}


	//is-link
	
}
</style>

<template>
<div class="wx-titlebar">
	<slot></slot>
</div>
</template>

<script>
export default {
    props: {
        part: {
			type: Boolean,
			default:false
        }
    }
};
</script>





// WEBPACK FOOTER //
// src/components/core/titlebar/Titlebar.vue